module.exports = __webpack_public_path__ + "img/login.c1d25c06.svg";